import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scroll_wrapper" }
const _hoisted_2 = { class: "scroll_content" }
const _hoisted_3 = { class: "scroll_list" }
const _hoisted_4 = {
  key: 0,
  class: "currency_content"
}
const _hoisted_5 = {
  key: 1,
  class: "currency_content"
}
const _hoisted_6 = { class: "scroll_list" }
const _hoisted_7 = {
  key: 0,
  class: "currency_content"
}
const _hoisted_8 = {
  key: 1,
  class: "currency_content"
}


import { PropType } from 'vue'
interface AssistList {
    phone: string,
    content: string,
    coin: number,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'reportData',
  props: {
    dataList: {
        type: Array as PropType<AssistList[]>,
    },
    reportDataHeight: {
        type: String,
        default: '195px'
    },
    reportDataMargin: {
        type: String,
        default: '0 25px'
    },
    colPadding: {
        type: String,
        default: '10px'
    },
    currencyTextSize: {
        type: String,
        default: '12px'
    },
    currencySpanTextSize: {
        type: String,
        default: '14px'
    },
    isReverse: {
        type: Boolean,
        default: false
    }

},
  setup(__props) {

const props = __props
const maskPhone = (phone: string) => {
    if (!phone || phone.length < 6) return phone;
    return phone.slice(0, 3) + '*******' + phone.slice(-3);
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "report_data",
    style: _normalizeStyle({ height: props.reportDataHeight, margin: props.reportDataMargin })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              key: `a-${index}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "8",
                  style: _normalizeStyle({ padding: props.colPadding })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(maskPhone(item.phone)), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_van_col, {
                  span: "10",
                  style: _normalizeStyle({ padding: props.colPadding })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.content), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "currency_col",
                  style: _normalizeStyle({ padding: props.colPadding })
                }, {
                  default: _withCtx(() => [
                    (!__props.isReverse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", {
                            class: "currency",
                            style: _normalizeStyle({ fontSize: props.currencyTextSize })
                          }, "R$", 4),
                          _createElementVNode("span", {
                            style: _normalizeStyle({ fontSize: props.currencySpanTextSize })
                          }, "+" + _toDisplayString(item.coin / 100), 5)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ fontSize: props.currencySpanTextSize })
                          }, "+" + _toDisplayString(item.coin / 100), 5),
                          _createElementVNode("div", {
                            class: "currency",
                            style: _normalizeStyle({ fontSize: props.currencyTextSize })
                          }, "R$", 4)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["style"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              key: `b-${index}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "8",
                  style: _normalizeStyle({ padding: props.colPadding })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(maskPhone(item.phone)), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_van_col, {
                  span: "10",
                  style: _normalizeStyle({ padding: props.colPadding })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.content), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "currency_col",
                  style: _normalizeStyle({ padding: props.colPadding })
                }, {
                  default: _withCtx(() => [
                    (!__props.isReverse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", {
                            class: "currency",
                            style: _normalizeStyle({ fontSize: props.currencyTextSize })
                          }, "R$", 4),
                          _createElementVNode("span", {
                            style: _normalizeStyle({ fontSize: props.currencySpanTextSize })
                          }, "+" + _toDisplayString(item.coin / 100), 5)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ fontSize: props.currencySpanTextSize })
                          }, "+" + _toDisplayString(item.coin / 100), 5),
                          _createElementVNode("div", {
                            class: "currency",
                            style: _normalizeStyle({ fontSize: props.currencyTextSize })
                          }, "R$", 4)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["style"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ])
    ])
  ], 4))
}
}

})